import { render, staticRenderFns } from "./FooterAccordion.vue?vue&type=template&id=79c99c2e"
import script from "./FooterAccordion.vue?vue&type=script&lang=js"
export * from "./FooterAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports